import React, { useMemo } from "react";

const ServicePage = ({ t = {}, setVueActuelle }) => {
  const steps = useMemo(
    () => [
      {
        k: "step1",
        title: t.step1Title || "1. Choisissez vos produits",
        text: t.step1Text || "Parcourez la sélection et ajoutez au panier.",
      },
      {
        k: "step2",
        title: t.step2Title || "2. Livraison ou retrait",
        text:
          t.step2Text ||
          "Sélectionnez le mode de récupération qui vous convient.",
      },
      {
        k: "step3",
        title: t.step3Title || "3. Finalisez facilement",
        text: t.step3Text || "Confirmez votre commande en quelques secondes.",
      },
    ],
    [t]
  );

  return (
    <div key="service" className="service-page page-transition">
      <header className="shop-header">
        <h1>{t.services || "Services"}</h1>
        <p className="service-subtitle">
          {t.servicesSubtitle ||
            "Une expérience simple, rapide et premium — du panier à la dégustation."}
        </p>
        {/* CTA header */}
        <div
          style={{ display: "flex", gap: 12, marginTop: 18, flexWrap: "wrap" }}
        >
          <button
            className="btn-luxury"
            onClick={() => setVueActuelle?.("magasin")}
            type="button"
          >
            {t.ctaShop || "Accéder au magasin"}
          </button>
          <button
            className="btn-luxury-outline"
            onClick={() => setVueActuelle?.("panier")}
            type="button"
          >
            {t.ctaCart || "Voir mon panier"}
          </button>
        </div>
      </header>

      {/* HOW IT WORKS */}
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "0 20px",
        }}
      >
        <div
          style={{
            marginTop: 24,
            padding: 18,
            borderRadius: 14,
            border: "1px solid rgba(212,175,55,.25)",
            background: "rgba(212,175,55,.06)",
          }}
        >
          <div
            style={{
              fontFamily: "var(--font-serif)",
              letterSpacing: 4,
              textTransform: "uppercase",
              marginBottom: 12,
              fontSize: 14,
            }}
          >
            {t.howItWorks || "Comment ça marche"}
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
              gap: 14,
            }}
          >
            {steps.map((s) => (
              <div
                key={s.k}
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: 14,
                  border: "1px solid rgba(0,0,0,.06)",
                }}
              >
                <div style={{ fontWeight: 900, marginBottom: 6 }}>
                  {s.title}
                </div>
                <div style={{ fontSize: 13, opacity: 0.8 }}>{s.text}</div>
              </div>
            ))}
          </div>
        </div>

        {/* CARDS */}
        <div
          className="service-grid-luxury"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: 25,
            marginTop: 26,
            padding: "10px 0 30px",
          }}
        >
          {/* Retrait */}
          <div
            className="service-card-premium"
            style={{
              background: "#fff",
              padding: 26,
              borderRadius: 16,
              border: "1px solid rgba(212,175,55,.35)",
              boxShadow: "0 14px 40px rgba(0,0,0,.05)",
              textAlign: "left",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ fontSize: 22 }}></div>
              <h2 style={{ margin: 0, color: "#8b4513" }}>
                {t.serviceReadyTitle || "Votre sélection prête à partir"}
              </h2>
            </div>

            <p style={{ fontSize: "0.92rem", color: "#555", marginTop: 10 }}>
              {t.serviceReadyText || "Commandez, Récupérez et Savourez."}
            </p>

            <ul style={{ marginTop: 14, paddingLeft: 18, color: "#555" }}>
              <li>{t.pick1 || "Préparation soignée et rapide"}</li>
              <li>{t.pick2 || "Retrait simple et efficace"}</li>
              <li>{t.pick3 || "Qualité premium, sans attente"}</li>
            </ul>

            <div
              style={{
                marginTop: 18,
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <button
                className="btn-luxury"
                type="button"
                onClick={() => setVueActuelle?.("magasin")}
              >
                {t.ctaOrder || "Commander maintenant"}
              </button>

              <button
                className="btn-luxury-outline"
                type="button"
                onClick={() => setVueActuelle?.("panier")}
              >
                {t.ctaFinalize || "Finaliser ma commande"}
              </button>
            </div>
          </div>

          {/* Livraison */}
          <div
            className="service-card-premium"
            style={{
              background: "#fff",
              padding: 26,
              borderRadius: 16,
              border: "1px solid rgba(212,175,55,.35)",
              boxShadow: "0 14px 40px rgba(0,0,0,.05)",
              textAlign: "left",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ fontSize: 22 }}></div>
              <h2 style={{ margin: 0, color: "#8b4513" }}>
                {t.deliveryTitle || "Livraison Locale (bientôt disponible)"}
              </h2>
            </div>

            <div style={{ marginTop: 10, fontSize: "0.92rem", color: "#555" }}>
              <p style={{ marginTop: 0 }}>
                {t.deliveryZone || "Livraison sur Neuchâtel et environs."}
              </p>

              {/* Badge gratuit */}
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "8px 12px",
                  borderRadius: 999,
                  background: "rgba(212,175,55,.10)",
                  border: "1px solid rgba(212,175,55,.25)",
                  fontWeight: 800,
                  marginBottom: 10,
                }}
              >
                ✨ {t.deliveryFree || "Gratuit dès 59.00 CHF"}
              </div>

              <div
                style={{
                  display: "grid",
                  gap: 8,
                  marginTop: 6,
                }}
              >
                <div
                  style={{
                    padding: 10,
                    borderRadius: 12,
                    border: "1px solid rgba(0,0,0,.06)",
                    background: "rgba(0,0,0,.02)",
                  }}
                >
                  <strong>{t.deliveryBeforeLabel || "Avant 12h00"}</strong> —{" "}
                  {t.deliveryBefore || "Livraison le jour même"}
                </div>

                <div
                  style={{
                    padding: 10,
                    borderRadius: 12,
                    border: "1px solid rgba(0,0,0,.06)",
                    background: "rgba(0,0,0,.02)",
                  }}
                >
                  <strong>{t.deliveryAfterLabel || "Après 12h00"}</strong> —{" "}
                  {t.deliveryAfter || "Livraison le lendemain"}
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: 18,
                display: "flex",
                gap: 10,
                flexWrap: "wrap",
              }}
            >
              <button
                className="btn-luxury"
                type="button"
                onClick={() => setVueActuelle?.("magasin")}
              >
                {t.ctaShop || "Accéder au magasin"}
              </button>
              <button
                className="btn-luxury-outline"
                type="button"
                onClick={() => setVueActuelle?.("panier")}
              >
                {t.ctaCart || "Voir mon panier"}
              </button>
            </div>
          </div>
        </div>

        {/* Mini FAQ simple (optionnel mais très UX) */}
        <div
          style={{
            marginTop: 10,
            padding: 18,
            borderRadius: 16,
            background: "#fff",
            border: "1px solid rgba(0,0,0,.06)",
            boxShadow: "0 10px 30px rgba(0,0,0,.04)",
          }}
        >
          <div
            style={{
              fontFamily: "var(--font-serif)",
              letterSpacing: 4,
              textTransform: "uppercase",
              marginBottom: 10,
              fontSize: 14,
            }}
          >
            {t.faq || "FAQ"}
          </div>

          <div
            style={{ display: "grid", gap: 10, color: "#555", fontSize: 13 }}
          >
            <div>
              <strong>{t.faqQ1 || "Puis-je commander sans compte ?"}</strong>
              <div style={{ opacity: 0.85 }}>
                {t.faqA1 ||
                  "Oui, vous pouvez commander en visiteur (prénom, nom, téléphone requis)."}
              </div>
            </div>
            <div>
              <strong>{t.faqQ2 || "Puis-je choisir un créneau ?"}</strong>
              <div style={{ opacity: 0.85 }}>
                {t.faqA2 ||
                  "Oui, en mode Pick & Pay vous choisissez votre horaire de retrait."}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServicePage;
